import React from 'react';
export function Header() {
  return <header className="sticky top-0 z-[200] bg-[#f9f6f1]/95 backdrop-blur-[10px] border-b border-border px-7 py-[13px] flex items-center justify-between" data-id="element-59">
      <a href="https://hund-juckreiz.napftagebuch.de" className="font-serif text-[0.95rem] font-bold text-text no-underline" data-id="element-60">
        napf<span className="text-amber font-normal italic" data-id="element-61">tagebuch</span>.de
      </a>
      <span className="font-sans text-[0.65rem] font-bold tracking-[0.13em] uppercase text-amber-deep bg-amber-lt rounded-[5px] px-[10px] py-1" data-id="element-62">
        Advertorial
      </span>
    </header>;
}